<template>
    <div class="view-body">
        <div class="view-body-type" v-if="orderParams.businessProperty == 3">
            <div class="body-type-item"
                :class="{'body-type-item-active': activeIndex == 0}"
                @click="activeIndex = 0">
                <span>物业配送</span>
                <div class="type-item-bg"></div>
            </div>
            <div class="body-type-item"
                :class="{'body-type-item-active': activeIndex == 1}"
                @click="activeIndex = 1">
                <span>到店自取</span>
                <div class="type-item-bg"></div>
            </div>
        </div>
        <div class="view-body-address">
            <div class="view-body-address-content">
                <p class="view-body-address-content_1">{{ sendAddress.title }}</p>
                <p class="view-body-address-content_2">{{ sendAddress.address }}</p>
                <p class="view-body-address-content_3">{{ sendAddress.userName }} {{ sendAddress.userPhone }}</p>
                <van-icon
                    v-if="orderParams.businessProperty == 2"
                    class="view-body-address-more"
                    name="arrow" color="#999999"
                    @click="$router.push('/address')" />
            </div>
            <van-field maxlength="50" show-word-limit v-model="message" rows="1" autosize label="订单备注：" type="textarea" placeholder="选填" />
        </div>
        <div class="view-body-content">
            <div class="view-body-content-head">
                <span class="view-body-content-head-icon"
                    :class="{
                        'view-body-content-head-icon-blue': orderParams.businessProperty == 3,
                        'view-body-content-head-icon-red': orderParams.businessProperty == 2,
                        'view-body-content-head-icon-yellow': orderParams.businessProperty == 4
                    }">{{ propertyType }}</span>
                <span class="view-body-content-head-title">{{ orderDetail.businessInfo.businessName }}</span>
            </div>
            <div class="view-body-content-shopping" v-for="(item,key) in orderDetail.shoppingCartList" :key="key">
                <div class="view-body-content-shoppingImg">
                    <img :src="getFirstImg(item.productImage)" alt="">
                </div>
                <div class="view-body-content-shoppingP">
                    <div class="view-body-content-shoppingP1">
                        <p>{{ item.productName }}</p>
                        <p>￥{{ item.productPrice }}</p>
                    </div>
                    <div class="view-body-content-shoppingP2 clearfix">
                        <p style="color: #999">x{{ item.productNum }}</p>
                        <p v-if="item.isOpenCredit === 1">￥{{ item.creditProductPrice || 0 }}+{{ item.needCredit || 0 }}积分</p>
                    </div>
                </div>
            </div>
            <div class="view-body-content-bottom">
                <p class="view-body-content-bottomFee">
                    配送费<span>￥{{ orderDetail.sendMoney }}</span>
                </p>
                <p class="view-body-content-bottomFee view-body-content-color" v-if="orderParams.businessProperty == 2||(orderParams.businessProperty == 3&&!checked)">
                    满减优惠<span>-￥{{ orderDetail.discountTopic.discountTotalMoney }}</span>
                </p>
                <p class="view-body-content-bottomIntegral" v-if="orderParams.businessProperty == 3">
                    积分抵扣&nbsp;可用{{ orderDetail.yzHadJifen }}积分<van-switch active-color="#07c160" v-model="checked" :disabled="discountEnable" @change="discountChange" />
                </p>
                <p class="view-body-content-bottomNum" v-show="orderParams.businessProperty == 3">满减活动与积分抵扣不同享</p>
                <p class="view-body-content-bottomNum" v-show="checked">使用<span>{{ orderDetail.needTotaljfdkNum || 0 }}</span>积分，可抵扣<span>{{ orderDetail.discountTopic.discountTotalMoney || 0 }}</span>元</p>
            </div>
        </div>
        <van-submit-bar :disabled="orderDetail.businessInfo.businessStatus==1?false:true" :button-text="orderDetail.businessInfo.businessStatus==1?'去支付':(orderDetail.businessInfo.businessStatus==2?'休业中':'禁用')" @submit="onSubmit">
            <template #default>
                <p class="van-submit-barP">
                    <span class="van-submit-barSpan1">合计</span>
                    <span class="van-submit-barSpan2">￥{{ orderDetail.discountTopic.realPayMoney }}</span>
                    <span class="van-submit-barSpan3">I 已优惠{{ orderDetail.discountTopic.discountTotalMoney }}元</span>
                </p>
            </template>
        </van-submit-bar>
    </div>
</template>
<script>
import baseUrl from '@/config/baseUrl';
import { mapActions, mapState } from 'vuex';
export default {
    data() {
        return {
            activeIndex: 0,
            message:'',
            checked: false,
            shoppingList:[
                {
                    img:'https://img.yzcdn.cn/vant/apple-1.jpg',
                    tietle:'山东大苹果1斤装',
                    price:'12',
                    num:'2',
                    remark:'￥0.8+500币'
                },
                {
                    img:'https://img.yzcdn.cn/vant/apple-1.jpg',
                    tietle:'山东大苹果1斤装',
                    price:'15',
                    num:'1',
                    remark:''
                }
            ],
            sendAddress: {
                title: '',
                address: '',
                userName: '',
                userPhone: ''
            },
            discountEnable: false,
            searchData: {
                ifJifenDikou: -1,
                ifPlanPsr: 2
            }
        };
    },
    computed: {
        ...mapState('confirmOrder', {
            orderParams: 'orderParams',
            orderDetail: 'orderDetail'
        }),
        ...mapState('user', {
            userInfo: 'userInfo'
        }),
        propertyType() {
            let businessProperty = parseInt(this.orderParams.businessProperty);
            if(businessProperty === 2) {
                return '缤纷';
            }else if(businessProperty === 3) {
                return '自营';
            }else if(businessProperty === 4) {
                return '周边';
            }
            return '';
        }
    },
    watch: {
        activeIndex() {
            if(this.activeIndex === 0) {
                this.setWyAddress();
                this.searchData.ifPlanPsr = 2;
            }else {
                this.setBusinessAddress();
                this.searchData.ifPlanPsr = 3;
            }
            this.searchDetail();
        }
    },
    methods: {
        ...mapActions('confirmOrder', {
            getOrderDetail: 'getOrderDetailAction',
            submitOrder: 'submitOrderAction'
        }),
        getFirstImg(s) {
            let arr = s.split(',');
            return arr.length ? baseUrl.imgUrl + arr[0] : '';
        },
        setWyAddress() {
            const { settedAddress, businessInfo: { businessProperty, deliverMethods } } = this.orderDetail;
            if(businessProperty === 2) {//缤纷精选
                this.sendAddress.title = '由商家配送至';
            }else if(businessProperty === 4 && deliverMethods === 1) {//周边商家且配送方式为商家配送
                this.sendAddress.title = '由商家配送至';
            }else {
                this.sendAddress.title = '由物业配送至';
            }
            if(businessProperty === 2) {
                if(settedAddress && settedAddress.id) {
                    this.sendAddress.address = settedAddress.shengMc + settedAddress.chengshiMc + settedAddress.quxianMc + settedAddress.detaileAddress;
                    this.sendAddress.userName = settedAddress.shrMc;
                    this.sendAddress.userPhone = settedAddress.phone;
                }else {
                    //拉取app内收货地址
                    this.sendAddress.userName = this.userInfo.name;
                    this.sendAddress.userPhone = this.userInfo.phone;
                    this.sendAddress.address = this.userInfo.address;
                }
            }else {
                //拉取app内收货地址
                this.sendAddress.userName = this.userInfo.name;
                this.sendAddress.userPhone = this.userInfo.phone;
                this.sendAddress.address = this.userInfo.address;
            }
        },
        setBusinessAddress() {
            const { businessInfo } = this.orderDetail;
            if(businessInfo) {
                this.sendAddress.title = '商家地址';
                this.sendAddress.address = businessInfo.businessAddress;
                this.sendAddress.userName = '商家电话';
                this.sendAddress.userPhone = businessInfo.businessPhone;
            }
        },
        discountChange(value) {
            const { yzHadJifen, needTotaljfdkNum } = this.orderDetail;
            if(needTotaljfdkNum>yzHadJifen) {
                this.$toast('用户积分不足');
                // this.discountEnable = true;
                this.checked = false;
            }else {
                this.searchData.ifJifenDikou = value ? 1 : -1;
                this.searchDetail();
            }
        },
        searchDetail(callback) {
            this.getOrderDetail({
                ...this.orderParams,
                ...this.searchData
            }).then((res) => {
                if(callback && typeof callback === 'function' ) {
                    callback(res);
                }
            });
        },
        onSubmit() {
            const {
                sendMoney,
                discountTopic: {
                    discountTotalMoney,
                    orderMoney,
                    realPayMoney,
                    jfdkNum,
                    sendJfNum
                },
                businessInfo: {
                    businessNumber,
                    businessProperty,
                    deliverMethods
                }
            } = this.orderDetail;
            let params = {
                productIds: this.orderParams.productIds,
                deliverMoney: sendMoney,
                orderRemarks: this.message,
                address: this.sendAddress.address,
                discountMoney: discountTotalMoney,
                orderMoney,
                orderFactoryMoney: realPayMoney,
                businessNumber,
                businessProperty,
                jfdkNum,
                sendJfNum,
                orderDeliverMethods: this.activeIndex === 1 ? 3 : deliverMethods,
                ifJifenDikou: this.searchData.ifJifenDikou,
                ifPlanPsr: this.searchData.ifPlanPsr
            };
            this.submitOrder(params).then((res) => {
                //调用app支付
                this.$commonPay({
                    data: {
                        xmBh:this.orderDetail.businessInfo.businessNumber+','+this.orderDetail.businessInfo.businessCompanyBonus+','+this.orderDetail.businessInfo.businessPlatformBonus+','+this.orderDetail.businessInfo.businessProperty+','+(this.orderDetail.businessInfo.deliverMethods===null?3:this.orderDetail.businessInfo.deliverMethods)+','+this.orderDetail.businessInfo.businessZhifuFeilv+','+this.orderDetail.sendMoney,
                        tradeNo:res.data.orderNumber,
                        totalFee:realPayMoney,
                        orderDesc:'欣商城',
                        gsbh:res.data.companyNumber
                    },
                    successFn: () => {
                        this.$router.back();
                    },
                    cancelFn: () => {
                        this.$router.push('/myOrder');
                    }
                });
            }).catch((res) => {
                this.$toast(res.error);
            });
        }
    },
    created() {
        this.searchDetail(() => {
            this.setWyAddress();
        });
    }
};
</script>
<style lang="scss" scoped>
.view-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 9px 10px;

    .view-body-type {
        display: flex;
        overflow: hidden;

        .body-type-item {
            flex: 1;
            position: relative;
            height: 45px;
            line-height: 45px;
            text-align: center;
            font-size: 15px;
            color: #666666;
            z-index: 1;

            .type-item-bg {
                position: absolute;
                width: 120%;
                height: 100%;
                top: 5px;
                bottom: 0;
                z-index: -2;
                border-radius: 3px;
                background-color: #F8F8F8;
                transition: all .2s;
                transform: scaleY(1.1) perspective(2.5em) rotateX(5deg);
            }
        }
        .body-type-item:first-child .type-item-bg {
            left: 5px;
            transform-origin: bottom left;
        }
        .body-type-item:last-child .type-item-bg {
            right: 5px;
            transform-origin: bottom right;
        }
        .body-type-item-active {
            z-index: 2;
            color: #000000;
            font-weight: bold;

            .type-item-bg {
                top: 0;
                background-color: #FFFFFF;
                width: 105%;
                right: 0px !important;
                left: 0px !important;
            }
        }
    }
    .view-body-address{
        background: #fff;
        border-radius: 2px;
        margin-bottom: 13px;
        .view-body-address-content{
            position: relative;
            padding: 5px;
            margin: 0 10px;
            border-bottom: 1px solid #EEE;
            .view-body-address-content_1{
                padding-right: 10px;
                font:12px/2 'PingFang SC';
                font-weight:400;
            }
            .view-body-address-content_2{
                padding-right: 10px;
                font-size:17px;
                font-family:PingFang SC;
                font-weight:bold;
                color:#1A1A1A;
                line-height: 30px;
            }
            .view-body-address-content_3{
                padding-right: 10px;
                font:12px/2 'PingFang SC';
                font-weight:400;
                color:#666;
            }
            .view-body-address-more {
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                font-size: 20px;
                height: 20px;
            }
        }
    }
    .view-body-content{
        background: #fff;
        border-radius: 5px;
        margin-bottom: 50px;
        .view-body-content-head{
            padding: 15px;
            .view-body-content-head-icon{
                display: inline-block;
                text-align: center;
                width:39px;
                border-radius:16px;
                font-size:12px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height: 16px;
            }
            .view-body-content-head-icon-blue {
                background-color: #2D95FE;
            }
            .view-body-content-head-icon-red {
                background-color: #EB5435;
            }
            .view-body-content-head-icon-yellow {
                background-color: #ED863F;
            }
            .view-body-content-head-title{
                display: inline-block;
                margin-left: 10px;
                font-size:15px;
                font-family:PingFang SC;
                font-weight:bold;
                color:#333;
            }
        }
        .view-body-content-shopping{
            border-bottom: 10px solid #fff;
            padding: 15px;
            display: flex;
            background: #F2F2F2;
            .view-body-content-shoppingImg{
                flex: 1;
                img{
                    width:50px;
                    height:50px;
                }
            }
            .view-body-content-shoppingP{
                flex: 6;
                margin-left: 10px;
                .view-body-content-shoppingP1{
                    font-size:15px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:#333;
                    display: flex;
                    min-width: 0;
                    margin-bottom: 10px;
                    p:first-child{
                        flex: 5;
                        white-space: nowrap;
                        text-overflow:ellipsis;
                        overflow:hidden;
                        width: 0;
                    }
                    p:last-child{
                        flex: 1;
                        text-align: right;
                    }
                }
                .view-body-content-shoppingP2{
                    font-size:15px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:#999;
                    p:last-child{
                        color:#333;
                        float: right;
                    }
                    p:first-child{
                        float: left;
                    }
                }
            }
        }
        .view-body-content-bottom{
            padding: 0 15px;
            .view-body-content-bottomFee{
                font-size:15px;
                font-family:PingFang SC;
                font-weight:500;
                color:#333333;
                line-height:30px;
                span{
                    font-weight: bold;
                    float: right;
                }
            }
            .view-body-content-color span {
                color: #EB5435;
            }
            .view-body-content-bottomIntegral{
                font-size:15px;
                font-family:PingFang SC;
                font-weight:500;
                color:#333333;
                line-height:30px;
                .van-switch{
                    float: right;
                    margin-top: 6px;
                    font-size:15px !important;
                }
            }
            .view-body-content-bottomNum{
                font-size:15px;
                font-family:PingFang SC;
                font-weight:500;
                color:#909090;
                line-height:30px;
                padding-bottom: 10px;
                span{
                    color: #FF3F3F;
                }
            }
        }
    }
    .van-submit-bar{
        .van-submit-barP{
            text-align: left;
            width: 100%;
            .van-submit-barSpan1{
                font-size:15px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(144,144,144,1);
                line-height:27px;
            }
            .van-submit-barSpan2{
                font-size:24px;
                font-family:PingFang SC;
                font-weight:bold;
                color:rgba(255,63,63,1);
                line-height:27px;
            }
            .van-submit-barSpan3{
                font-size:12px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(102,102,102,1);
                line-height:27px;
                margin-left: 5px;
            }
        }
    }
}
</style>